import {
	createResource,
	type RouterDataContext,
	type RouterContext,
} from '@atlassian/react-resource-router';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const PROPERTY_KEY = 'csmGetStartedCustomerExperienceDisabled';

const getUrl = (projectKey: string | number, key: string) =>
	`/rest/api/3/project/${projectKey}/properties/${key}`;

export const getStartedPropertyResource = createResource<boolean>({
	type: 'CUSTOMER_SERVICE_GET_STARTED_PROPERTY_RESOURCE',
	getKey: ({ match }: RouterContext) =>
		`customer-service-get-started-property-${match.params.projectKey}`,
	getData: async ({ match }: RouterDataContext) =>
		fetchJson<boolean>(getUrl(match.params.projectKey || '', PROPERTY_KEY)),
});
